/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
// import _ from "lodash";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import {
  getTrainingDetail,
  cancelEmployeeRegistrationTraining,
  createEmployeeRegistrationTraining,
  createTrainingRequest,
  doPlanTrainingRequest,
  showModal,
} from "actions";
import "components/widgets/training/TrainingDetail.css";
import { Table } from "react-bootstrap";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import { Trans } from "react-i18next";

class TrainingDetailGeneral extends Component {
  state = {
    mainTrainingId: this.props.id,
    trainingDetailData: null,
    selectedTraining: this.props.id,
    selectedTimeplan: null,
    selectedChildTimeplan: null,
    selectedQuarter: null,
    selectedYear: new Date().getFullYear(),
    isManager: null,
    blocking: false,
    blockingMessage: "",
    quarters: [],
    years: [
      {
        key: new Date().getFullYear(),
        value: new Date().getFullYear(),
        text: new Date().getFullYear(),
      },
      {
        key: new Date().getFullYear() + 1,
        value: new Date().getFullYear() + 1,
        text: new Date().getFullYear() + 1,
      },
      {
        key: new Date().getFullYear() + 2,
        value: new Date().getFullYear() + 2,
        text: new Date().getFullYear() + 2,
      },
    ],
  };

  componentDidMount() {
    this.props.handleTimeplanSelected(this.state.selectedTimeplan?.timePlanId);
    this.fetchTrainingDetail(this.state.mainTrainingId);
    let roles = localStorage.getItem("roles");
    this.setState({ isManager: roles != null && roles.includes("Manager") });

    //Quarterliklerin ilk açılışta yıla göre uygun olanlarının görünmesi için
    this.selectedYearOnChange(this.state.selectedYear);
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.selectedTimeplan !== this.state.selectedTimeplan) {
      this.props.handleTimeplanSelected(
        this.state.selectedTimeplan?.timePlanId
      );
    }
  };

  fetchTrainingDetail = (id) => {
    this.props.getTrainingDetail(
      id,
      this.onBeginFetch,
      this.onSuccessFetch,
      this.onErrorFetch
    );
  };
  onBeginFetch = () => {
    this.props.onProcessBegin();
  };
  onSuccessFetch = (res) => {
    this.props.onProcessEnd();

    if (!res.isParent)
      res.timeplans = this.timePlanFilter(res.timeplans, this.props.startDate);

    let _selectedTimePlan = null;
    if (res.timeplans && res.timeplans.length !== 0) {
      _selectedTimePlan =
        res.timeplans.find((z) => z.timePlanId === this.props.timeplanId) ??
        res.timeplans[0];
    }

    // paket egitimler icin yapilan islemler
    let _selectedChildTimeplan = null;
    if (res.childTrainings && res.childTrainings.length !== 0) {
      const _childTimeplans = [
        ...res.childTrainings
          .filter((z) => z.timeplans && z.timeplans.length !== 0)
          .map((z) => z.timeplans)
          .flat(),
      ];
      _selectedChildTimeplan =
        _childTimeplans.find(
          (z) => z.relatedPackageTimePlanId === _selectedTimePlan?.timePlanId
        ) ?? null;
    }

    this.setState({
      trainingDetailData: res,
      selectedTimeplan: _selectedTimePlan,
      selectedChildTimeplan: _selectedChildTimeplan,
    });
  };
  onErrorFetch = (e) => {
    this.props.onProcessEnd();
    console.log(e);
  };

  timePlanFilter = (timePlans, startDate) => {
    if (!timePlans) return null;
    if (!startDate) return timePlans;

    let _timePlans = timePlans.filter(
      (z) =>
        new Date(z.startDate).toLocaleDateString() ===
        new Date(startDate).toLocaleDateString()
    );
    if (!_timePlans) return null;
    else return _timePlans;
  };

  cancelEmployeeRegistrationTraining = (employeeId) => {
    let timePlanId = this.state.selectedTimeplan.timePlanId;
    let isPackage =
      this.state.trainingDetailData.childTrainings !== null &&
      this.state.trainingDetailData.childTrainings.length > 0;
    this.props.cancelEmployeeRegistrationTraining(
      employeeId,
      timePlanId,
      isPackage,
      this.onCancelEmployeeRegistrationTrainingBegin,
      this.onCancelEmployeeRegistrationTrainingSuccess,
      this.onCancelEmployeeRegistrationTrainingError
    );
  };
  onCancelEmployeeRegistrationTrainingBegin = (target) => {
    this.setState({
      blocking: true,
      blockingMessage: <Trans desc="İptal işlemi yapılıyor, lütfen bekleyiniz.">trainingdetail_general_cancel</Trans>,
    });
  };
  onCancelEmployeeRegistrationTrainingSuccess = (res) => {
    this.setState({
      blocking: true,
      blockingMessage: <Trans desc="İptal işlemi başarılı bir şekilde gerçekleşti.">trainingdetail_general_cancel_completed</Trans>,
    });
    setTimeout(() => {
      this.setState({ blocking: false, blockingMessage: "" });
      this.fetchTrainingDetail(this.state.mainTrainingId);
    }, 1500);
  };
  onCancelEmployeeRegistrationTrainingError = (err) => {
    //console.dir(err);
    this.setState({
      blocking: true,
      blockingMessage: err.response?.data?.message,
    });
    setTimeout(() => {
      this.setState({ blocking: false, blockingMessage: "" });
    }, 5000);
  };

  createEmployeeRegistrationTraining = (employeeId) => {
    let timePlanId = this.state.selectedTimeplan.timePlanId;
    let isPackage =
      this.state.trainingDetailData.childTrainings !== null &&
      this.state.trainingDetailData.childTrainings.length > 0;

    this.props.createEmployeeRegistrationTraining(
      employeeId,
      timePlanId,
      isPackage,
      this.onCreateEmployeeRegistrationTrainingBegin,
      this.onCreateEmployeeRegistrationTrainingSuccess,
      this.onCreateEmployeeRegistrationTrainingError
    );
  };
  onCreateEmployeeRegistrationTrainingBegin = (target) => {
    this.setState({
      blocking: true,
      blockingMessage: <Trans desc="Kayıt işlemi yapılıyor, lütfen bekleyiniz.">trainingdetail_general_success</Trans>,
    });
  };
  onCreateEmployeeRegistrationTrainingSuccess = (res) => {
    this.setState({
      blocking: true,
      blockingMessage: <Trans desc="Kayıt işlemi başarılı şekilde gerçekleşti.">trainingdetail_general_complate</Trans>,
    });
    setTimeout(() => {
      this.setState({ blocking: false, blockingMessage: "" });
      this.fetchTrainingDetail(this.state.mainTrainingId);
    }, 1500);
  };
  onCreateEmployeeRegistrationTrainingError = (err) => {
    //console.dir(err);
    this.setState({
      blocking: true,
      blockingMessage: err.response?.data?.message,
    });
    setTimeout(() => {
      this.setState({ blocking: false, blockingMessage: "" });
    }, 5000);
  };

  createRequestByManager = (employeeId) => {
    let isPackage =
      this.state.trainingDetailData.childTrainings !== null &&
      this.state.trainingDetailData.childTrainings.length > 0;
    let trainingId = this.state.selectedTraining;
    let quarter = this.state.selectedQuarter;
    let year = this.state.selectedYear;

    this.props.doPlanTrainingRequest(
      employeeId,
      trainingId,
      quarter,
      year,
      isPackage,
      this.onCreateRequestByManagerBegin,
      this.onCreateRequestByManagerSuccess,
      this.onCreateRequestByManagerError
    );
  };
  onCreateRequestByManagerBegin = (target) => {
    this.setState({
      blocking: true,
      blockingMessage: <Trans desc="Talep etme işlemi yapılıyor, lütfen bekleyiniz.">trainingdetail_general_request</Trans>,
    });
  };
  onCreateRequestByManagerSuccess = (res) => {
    this.setState({
      blocking: true,
      blockingMessage: <Trans desc="Talep etme işlemi başarılı şekilde gerçekleşti.">trainingdetail_general_request_complated</Trans>,
    });
    setTimeout(() => {
      this.setState({ blocking: false, blockingMessage: "" });
      this.fetchTrainingDetail(this.state.mainTrainingId);
    }, 1500);
  };
  onCreateRequestByManagerError = (err) => {
    //console.dir(err);
    this.setState({
      blocking: true,
      blockingMessage: err.response?.data?.message,
    });
    setTimeout(() => {
      this.setState({ blocking: false, blockingMessage: "" });
    }, 5000);
  };

  createRequestByEmployee = () => {
    let isPackage =
      this.state.trainingDetailData.childTrainings !== null &&
      this.state.trainingDetailData.childTrainings.length > 0;
    let trainingId = this.state.selectedTraining;

    if (
      this.state.trainingDetailData.timeplans !== null &&
      this.state.trainingDetailData.timeplans.length > 0
    ) {
      let timePlanId = this.state.selectedTimeplan.timePlanId;
      this.props.createTrainingRequest(
        isPackage,
        trainingId,
        timePlanId,
        this.onCreateRequestByEmployeeBegin,
        this.onCreateRequestByEmployeeSuccess,
        this.onCreateRequestByEmployeeError
      );
    } else {
      let quarter = this.state.selectedQuarter;
      let year = this.state.selectedYear;
      this.props.doPlanTrainingRequest(
        "00000000-0000-0000-0000-000000000000",
        trainingId,
        quarter,
        year,
        isPackage,
        this.onCreateRequestByEmployeeBegin,
        this.onCreateRequestByEmployeeSuccess,
        this.onCreateRequestByEmployeeError
      );
    }
  };
  onCreateRequestByEmployeeBegin = (target) => {
    this.setState({
      blocking: true,
      blockingMessage: "Talep etme işlemi yapılıyor, lütfen bekleyiniz.",
    });
  };
  onCreateRequestByEmployeeSuccess = (res) => {
    this.setState({
      blocking: true,
      blockingMessage: "Talep etme işlemi başarılı şekilde gerçekleşti",
    });
    setTimeout(() => {
      this.setState({ blocking: false, blockingMessage: "" });
      this.fetchTrainingDetail(this.state.mainTrainingId);
    }, 1500);
  };
  onCreateRequestByEmployeeError = (err) => {
    //console.dir(err);
    this.setState({
      blocking: true,
      blockingMessage: err.response?.data?.message,
    });
    setTimeout(() => {
      this.setState({ blocking: false, blockingMessage: "" });
    }, 5000);
  };

  handleSelectChildTraining = (e) => {
    this.setState({ selectedTraining: e.target.value });
    let timePlans = this.state.trainingDetailData.childTrainings.find(
      (z) => z.training.id === e.target.value
    )?.timeplans;
    if (!timePlans || timePlans.length === 0) return;

    this.setState({
      selectedChildTimeplan: timePlans.find(
        (z) =>
          z.relatedPackageTimePlanId === this.state.selectedTimeplan?.timePlanId
      ),
    });
  };

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };

  renderTime = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleTimeString(localStorage.getItem("i18nextLng"));
  };

  renderDateTime = (dateString) => {
    return `${this.renderDate(dateString)} ${this.renderTime(
      dateString
    ).replace(/(:\d{2}| [AP]M)$/, "")}`;
  };

  renderAction = () => {
    if (this.state.isManager) return null;

    return (
      <div
        style={{ gridColumnStart: "4", gridColumnEnd: "5", justifySelf: "end" }}
      >
        <button
          className="egitim-talep"
          onClick={() => this.createRequestByEmployee()}
        >
          <Trans desc="Talep Et">10377</Trans>
        </button>
      </div>
    );
  };

  renderChildTrainingsCombo = () => {
    if (this.state.trainingDetailData.childTrainings.length === 0) return null;

    return (
      <>
        <div className="trainingDetailGeneralLabel">
          Pakete bağlı eğitimler:
        </div>
        <div style={{ gridColumnStart: "2", gridColumnEnd: "5" }}>
          <select
            value={this.state.selectedTraining}
            onChange={(e) => this.handleSelectChildTraining(e)}
          >
            {this.state.trainingDetailData.childTrainings.map((ct) => {
              return (
                <option value={ct.training.id} key={ct.training.id}>
                  {ct.training.name} (
                  {this.renderDate(
                    ct.timeplans.find(
                      (z) =>
                        z.relatedPackageTimePlanId ===
                        this.state.selectedTimeplan?.timePlanId
                    )?.startDate
                  )}{" "}
                  -{" "}
                  {this.renderDate(
                    ct.timeplans.find(
                      (z) =>
                        z.relatedPackageTimePlanId ===
                        this.state.selectedTimeplan?.timePlanId
                    )?.endDate
                  )}
                  )
                </option>
              );
            })}
          </select>
        </div>
      </>
    );
  };

  renderTimeSlots = () => {
    if (
      this.state.trainingDetailData.timeplans &&
      this.state.trainingDetailData.timeplans.length > 0
    )
      return null;

    return (
      <>
        <div className="trainingDetailGeneralLabel">
          <Trans desc="Zaman Planı Yıl">10556</Trans>:
        </div>
        <div style={{ gridColumnStart: "2", gridColumnEnd: "5" }}>
          <select
            value={this.state.selectedYear}
            onChange={(e) =>
              this.selectedYearOnChange(parseInt(e.target.value))
            }
          >
            {this.state.years.map((q) => {
              return (
                <option key={q.key} value={q.value}>
                  {q.text}
                </option>
              );
            })}
          </select>
        </div>

        <div className="trainingDetailGeneralLabel">
          <Trans desc="Zaman Planı">10364</Trans>:
        </div>
        <div style={{ gridColumnStart: "2", gridColumnEnd: "5" }}>
          <select
            value={this.state.selectedQuarter}
            onChange={(e) =>
              this.setState({ selectedQuarter: parseInt(e.target.value) })
            }
          >
            {this.state.quarters.map((q) => {
              return (
                <option key={q.key} value={q.value}>
                  {q.text}
                </option>
              );
            })}
          </select>
        </div>
      </>
    );
  };

  selectedYearOnChange = (year) => {
    this.setState({ selectedYear: year });

    const _quarters = [];

    if (
      new Date(year, 0, 1).getTime() <= new Date().getTime() &&
      new Date(year, 2, 31, 23, 59, 59).getTime() >= new Date().getTime()
    ) {
      _quarters.push({
        key: "717710000",
        value: 717710000,
        text: "1. Quarter (1 January - 31 March)",
      });
      _quarters.push({
        key: "717710001",
        value: 717710001,
        text: "2. Quarter (1 April - 30 June)",
      });
      _quarters.push({
        key: "717710002",
        value: 717710002,
        text: "3. Quarter (1 July - 30 September)",
      });
      _quarters.push({
        key: "717710003",
        value: 717710003,
        text: "4. Quarter (1 October - 31 December)",
      });
    }

    if (
      new Date(year, 3, 1).getTime() <= new Date().getTime() &&
      new Date(year, 6, 30, 23, 59, 59).getTime() >= new Date().getTime()
    ) {
      _quarters.push({
        key: "717710001",
        value: 717710001,
        text: "2. Quarter (1 April - 30 June)",
      });
      _quarters.push({
        key: "717710002",
        value: 717710002,
        text: "3. Quarter (1 July - 30 September)",
      });
      _quarters.push({
        key: "717710003",
        value: 717710003,
        text: "4. Quarter (1 October - 31 December)",
      });
    }

    if (
      new Date(year, 7, 1).getTime() <= new Date().getTime() &&
      new Date(year, 8, 30, 23, 59, 59).getTime() >= new Date().getTime()
    ) {
      _quarters.push({
        key: "717710002",
        value: 717710002,
        text: "3. Quarter (1 July - 30 September)",
      });
      _quarters.push({
        key: "717710003",
        value: 717710003,
        text: "4. Quarter (1 October - 31 December)",
      });
    }

    if (
      new Date(year, 9, 1).getTime() <= new Date().getTime() &&
      new Date(year, 11, 31, 23, 59, 59).getTime() >= new Date().getTime()
    ) {
      _quarters.push({
        key: "717710003",
        value: 717710003,
        text: "4. Quarter (1 October - 31 December)",
      });
    }

    if (year > new Date().getFullYear()) {
      _quarters.push({
        key: "717710000",
        value: 717710000,
        text: "1. Quarter (1 January - 31 March)",
      });
      _quarters.push({
        key: "717710001",
        value: 717710001,
        text: "2. Quarter (1 April - 30 June)",
      });
      _quarters.push({
        key: "717710002",
        value: 717710002,
        text: "3. Quarter (1 July - 30 September)",
      });
      _quarters.push({
        key: "717710003",
        value: 717710003,
        text: "4. Quarter (1 October - 31 December)",
      });
    }

    this.setState({ selectedQuarter: _quarters[0].value });
    this.setState({ quarters: _quarters });
  };

  renderTimeplans = () => {
    if (
      !this.state.trainingDetailData.timeplans ||
      this.state.trainingDetailData.timeplans.length === 0
    )
      return null;

    return (
      <>
        <div className="trainingDetailGeneralLabel">
          <Trans desc="Zaman Planı">10364</Trans>:
        </div>
        <div style={{ gridColumnStart: "2", gridColumnEnd: "5" }}>
          <select
            value={this.state.selectedTimeplan?.timePlanId}
            onChange={(e) => {
              let selectedTimePlan =
                this.state.trainingDetailData.timeplans.find(
                  (z) => z.timePlanId === e.target.value
                );
              this.setState({ selectedTimeplan: selectedTimePlan });

              // paket egitimler icin yapilan islemler
              if (this.state.trainingDetailData.isParent) {
                let _selectedChildTimeplan = null;
                if (
                  this.state.trainingDetailData.childTrainings &&
                  this.state.trainingDetailData.childTrainings.length !== 0
                ) {
                  const _childTimeplans = [
                    ...this.state.trainingDetailData.childTrainings
                      .filter((z) => z.timeplans && z.timeplans.length !== 0)
                      .map((z) => z.timeplans)
                      .flat(),
                  ];
                  _selectedChildTimeplan =
                    _childTimeplans.find(
                      (z) =>
                        z.relatedPackageTimePlanId ===
                        selectedTimePlan?.timePlanId
                    ) ?? null;
                  this.setState({
                    selectedChildTimeplan: _selectedChildTimeplan,
                  });
                }
              }
            }}
          >
            {this.state.trainingDetailData.timeplans.map((tp) => {
              return (
                <option key={tp.timePlanId} value={tp.timePlanId}>
                  {`${this.renderDateTime(
                    tp.startDate
                  )} - ${this.renderDateTime(tp.endDate)} (GMT +3:00)`}
                </option>
              );
            })}
          </select>
        </div>
        {this.renderTimePlanDetail()}
      </>
    );
  };

  renderTimePlanDetail = () => {
    let isPackage =
      this.state.trainingDetailData.childTrainings !== null &&
      this.state.trainingDetailData.childTrainings.length > 0;

    const tp = isPackage
      ? this.state.selectedChildTimeplan
      : this.state.selectedTimeplan;
    if (!tp) return null;
    return (
      <>
        <div className="trainingDetailGeneralLabel">
          <Trans desc="Eğitim Tarihi">10365</Trans>:
        </div>
        <div>{this.renderDate(tp.startDate)}</div>
        <div className="trainingDetailGeneralLabel">
          <Trans desc="Eğitim Bitiş">10366</Trans>:
        </div>
        <div>{this.renderDate(tp.endDate)}</div>
        <div className="trainingDetailGeneralLabel">
          <Trans desc="Eğitmen">10367</Trans>:
        </div>
        <div>{tp.trainer?.name}</div>
        <div className="trainingDetailGeneralLabel">
          <Trans desc="Konum ve Sınıf">10368</Trans>:
        </div>
        <div>{`${tp.location}, ${tp.class?.name}`}</div>

        <div className="trainingDetailGeneralLabel">
          <Trans desc="Kontenjan">10598</Trans>:
        </div>
        <div>{tp.quota}</div>
        <div className="trainingDetailGeneralLabel">
          <Trans desc="Uygun Kontenjan">10599</Trans>:
        </div>
        <div>{tp.availableQuota}</div>

        <div className="trainingDetailGeneralLabel">
          <Trans desc="Adres">10369</Trans>:
        </div>
        <div>{tp.address}</div>
        {this.state.isManager && (
          <>
            <div className="trainingDetailGeneralLabel">
              <Trans desc="Eğitim Ücreti">training_detail_unitprice</Trans>:
            </div>
            <div>{tp.formattedPricePerUnit}</div>
          </>
        )}
        <div className="trainingDetailGeneralLabel">
          <Trans desc="Açıklaması">10370</Trans>:
        </div>
        <div style={{ gridColumnStart: "2", gridColumnEnd: "5" }}>
          {this.state.trainingDetailData.description}
        </div>
      </>
    );
  };

  renderEmployeesTable = () => {
    if (!this.state.isManager) return;

    let employees = [];

    if (
      this.state.selectedTimeplan !== null &&
      this.state.selectedTimeplan.employees !== null
    )
      employees = this.state.selectedTimeplan.employees.map((z) => {
        return {
          description: z.description,
          employee: z.employee,
          position: z.position,
          requestButtonType: z.requestButtonType,
        };
      });

    let canMake = this.state.trainingDetailData.employeesCanMakeRequests.map(
      (z) => {
        return {
          description: z.description,
          employee: z.employee,
          position: z.position,
          requestButtonType: z.requestButtonType,
        };
      }
    );

    employees = employees.concat(canMake);

    return (
      <>
        <div style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
          <Trans desc="Çalışanlar">10371</Trans>
        </div>
        <div style={{ gridColumnStart: "1", gridColumnEnd: "5" }}>
          <Table striped bordered hover responsive size="sm">
            <thead>
              <tr>
                <th>
                  <Trans desc="Ad Soyad">10372</Trans>
                </th>
                <th>
                  <Trans desc="Position">10373</Trans>
                </th>
                <th>
                  <Trans desc="Açıklama">10374</Trans>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {employees.map((emp) => {
                return (
                  <tr key={emp.employee?.id}>
                    <td>{emp.employee?.name}</td>
                    <td>{emp.position?.name}</td>
                    <td>{emp.description}</td>
                    <td>
                      {this.renderActionButton(emp.requestButtonType, emp)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </>
    );
  };

  renderActionButton = (buttonType, emp) => {
    /*
    None = 0,
    RegisterButton = 1,
    CreateRequestByManager = 2,
    CancelButton = 4,
    WaitingForApprove = 5
  */

    let button = null;
    switch (buttonType) {
      case "None":
        button = null;
        break;
      case "RegisterButton":
        button = this.renderCreateEmployeeRegistrationTrainingButton(
          emp.employee.id
        );
        break;
      case "CreateRequestByManager":
        button = this.renderCreateRequestByManagerButton(emp.employee.id);
        break;
      case "CancelButton":
        button = this.renderCancelEmployeeRegistrationTrainingButton(
          emp.employee.id
        );
        break;
      case "WaitingForApprove":
        button = null;
        break;
      default:
        button = null;
        break;
    }

    return button;
  };
  renderCreateEmployeeRegistrationTrainingButton = (employeeId) => {
    return (
      <button
        className="egitim-kaydet"
        onClick={() => this.createEmployeeRegistrationTraining(employeeId)}
      >
        <Trans desc="Kaydet">10375</Trans>
      </button>
    );
  };
  renderCreateRequestByManagerButton = (employeeId) => {
    return (
      <button
        className="egitim-talep"
        onClick={() => this.createRequestByManager(employeeId)}
      >
        <Trans desc="Talep Et">10377</Trans>
      </button>
    );
  };

  renderCancelEmployeeRegistrationTrainingButton = (employeeId) => {
    return (
      <button
        className="egitim-iptal"
        onClick={() => this.cancelEmployeeRegistrationTraining(employeeId)}
      >
        <Trans desc="İptal">10376</Trans>
      </button>
    );
  };

  renderTrainingDetail = () => {
    if (!this.state.trainingDetailData)
      return (
        <div
          style={{
            gridColumnStart: "1",
            gridColumnEnd: "5",
            gridRow: "1/-1",
            position: "relative",
          }}
        >
          {this.props.spinner}
        </div>
      );

    return (
      <>
        <div style={{ display: "none" }} className="trainingDetailGeneralLabel">
          ID:
        </div>
        <div
          style={{ display: "none", gridColumnStart: "2", gridColumnEnd: "5" }}
        >
          {this.props.id}
        </div>
        <div style={{ display: "none" }} className="trainingDetailGeneralLabel">
          Selected Time Plan ID:
        </div>
        <div
          style={{ display: "none", gridColumnStart: "2", gridColumnEnd: "5" }}
        >
          {this.state.selectedTimeplan?.timePlanId}
        </div>

        <div className="trainingDetailGeneralLabel">
          <Trans desc="Eğitim Adı">10363</Trans>:
        </div>
        <div style={{ gridColumnStart: "2", gridColumnEnd: "5" }}>
          {this.state.trainingDetailData.training.name}
        </div>
        {this.renderChildTrainingsCombo()}
        {this.renderTimeSlots()}
        {this.renderTimeplans()}
        {this.renderEmployeesTable()}
        {this.renderAction()}
      </>
    );
  };

  render() {
    return (
      <BlockUi
        tag="div"
        blocking={this.state.blocking}
        message={
          <div className={"block-ui-message-box"}>
            <span>{this.state.blockingMessage}</span>
          </div>
        }
        keepInView
        loader={<div></div>}
      >
        <div className="trainingDetailContainer">
          {this.renderTrainingDetail()}
        </div>
      </BlockUi>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let obj = {
    modal: state.modal,
  };

  return obj;
};

export default connect(mapStateToProps, {
  getTrainingDetail,
  cancelEmployeeRegistrationTraining,
  createEmployeeRegistrationTraining,
  createTrainingRequest,
  doPlanTrainingRequest,
  showModal,
})(containsLongRunningProcess(TrainingDetailGeneral));
